import React from "react";
import { styled, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import svgs from "../images/categories";
import { navigateToTop } from "../../common/utils";
import { Context } from "../../common/context";
import type { ContextValue, AdminConfig } from "../../types";

const Wrap = styled(Box)<{ isTop?: boolean }>(({ isTop }) => ({
    ...(isTop ? { flexDirection: `column`, textAlign: `center` } : {}),
    height: `auto`,
    margin: isTop ? `0 10px` : 10,
    cursor: `pointer`,
    padding: `12px `,
    borderRadius: 10,
    background: `#fff`,
    border: `1px solid #EEE`,
    flexGrow: 1,
    transition: `transform .2s ease`,
    display: `flex`,
    justifyContent: `space-evenly`,
    alignItems: `center`,

    "&:hover": {
        transform: `translateY(-5px)`,
    },
}));

interface CategoryBoxSmallProps {
    cName: string;
    top?: boolean;
    // Extra props passed from parent layouts but not used by this component
    width?: number;
    size?: string;
    context?: object;
    margin?: number;
}

const CategoryBoxSmall = ({ cName, top }: CategoryBoxSmallProps): React.ReactElement => {
    const navigate = useNavigate();

    const goToCategory = (): void => {
        navigateToTop(navigate, `/search?c=${encodeURIComponent(cName)}`);
    };

    return (
        <Context.Consumer>
            {(value: ContextValue) => (
                <Wrap isTop={top} onClick={goToCategory}>
                    {svgs[cName?.replace(/[ &+!,]/g, ``)] && (
                        <Box
                            sx={{
                                height: top ? 45 : 25,
                                width: top ? 45 : 25,
                                display: `inline-block`,
                                ...(top ? { marginBottom: `10px` } : { marginRight: `10px` }),
                                verticalAlign: `middle`,
                            }}
                            dangerouslySetInnerHTML={{
                                __html: svgs[cName?.replace(/[ &+!,]/g, ``)]({
                                    main_color: (value.getValue(`adminConfig`) as AdminConfig)?.mall?.main_color ?? ``,
                                }),
                            }}
                        />
                    )}

                    <Box
                        sx={{
                            display: `inline-block`,
                            fontSize: 16,
                            verticalAlign: `middle`,
                            fontWeight: 500,
                            textWrap: `nowrap`,
                        }}
                    >
                        {cName}
                    </Box>
                </Wrap>
            )}
        </Context.Consumer>
    );
};

export default CategoryBoxSmall;
